<template>
  <div class="creative-wrap">
    <div class="seletc-list">
      <el-select
        class="select-wrap multiple-select"
        v-model="filterData.advertiserIds"
        placeholder="请选择广告账号"
        @change="clickSearch(false)"
        multiple
        filterable
        collapse-tags
        clearable
        popper-class="promotion-create-filter-table-select"
      >
        <el-option
          v-for="item of advertiserIdList"
          :key="item.advertiserId"
          :label="item.company + '（' + item.advertiserId + '）'"
          :value="item.advertiserId"
        >
        </el-option>
      </el-select>
      <el-select
        class="select-wrap multiple-select"
        v-model="filterData.campaignIds"
        placeholder="请选择推广计划"
        @change="clickSearch(false)"
        remote
        filterable
        :loading="campaignLoading"
        multiple
        clearable
        :remote-method="remoteMethod"
        collapse-tags
        popper-class="promotion-create-filter-table-select"
      >
        <el-option
          v-for="item of campaignIdList"
          :key="item.campaignId"
          :label="item.campaignName"
          :value="item.campaignId"
        >
        </el-option>
      </el-select>
      <el-select
        class="select-wrap multiple-select"
        v-model="filterData.adIds"
        filterable
        multiple
        collapse-tags
        remote
        :loading="adLoading"
        clearable
        :remote-method="searchAdList"
        placeholder="请选择广告组"
        @change="clickSearch(false)"
        popper-class="promotion-create-filter-table-select"
      >
        <el-option
          v-for="item of adList"
          :key="item.adGroupId"
          :label="item.adGroupName"
          :value="item.adGroupId"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="filterData.productIds"
        collapse-tags
        clearable
        filterable
        multiple
        class="select-wrap multiple-select"
        placeholder="选择产品"
        @change="clickSearch(false)"
        popper-class="promotion-create-filter-table-select"
      >
        <el-option
          v-for="item of appList"
          :key="item.app_cloud_id"
          :label="item.app_name + '（' + item.package_name + '）'"
          :value="item.app_cloud_id"
        >
        </el-option>
      </el-select>
      <el-select
        class="select-wrap"
        v-model="filterData.systemStatus"
        placeholder="选择状态"
        @change="clickSearch()"
      >
        <el-option label="全部状态" :value="-1"> </el-option>
        <el-option
          v-for="item of optionsList.filterStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        class="data-range"
        v-model="filterData.time"
        type="daterange"
        range-separator="→"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width: 240px"
        value-format="yyyy-MM-dd"
        :clearable="false"
        @change="clickSearch(false)"
      >
      </el-date-picker>
    </div>
    <div class="content-wrap">
      <div class="btn-list">
        <el-select
          style="width: 350px; margin-right: 24px"
          v-model="filterData.creativeIds"
          placeholder="请选择创意"
          @change="clickSearch(false)"
          remote
          filterable
          :loading="createLoading"
          multiple
          clearable
          :remote-method="searchCreate"
          collapse-tags
          popper-class="promotion-create-filter-table-select"
        >
          <el-option
            v-for="item of createList"
            :key="item.campaignId"
            :label="item.adName"
            :value="item.adId"
          >
          </el-option>
        </el-select>
        <div class="mult-wrap">
          <el-button class="top-btn" style="margin-right: 16px" @click="showPlBox = true">
            <svg-icon iconClass="pl" className="pl-icon"></svg-icon>批量操作</el-button
          >
          <span class="piliang border-bg" v-show="showPlBox">
            <span class="batch-span"
              >已选择<a>{{ checkedList.length }}</a
              >账户</span
            >
            <div class="icon-list">
              <el-tooltip content="开始" placement="top">
                <svg-icon
                  iconClass="start"
                  className="batch-icon"
                  @click="editStatus(1)"
                ></svg-icon>
              </el-tooltip>
              <el-tooltip content="暂停" placement="top">
                <svg-icon iconClass="stop" className="batch-icon" @click="editStatus(2)"></svg-icon>
              </el-tooltip>
              <!-- <span class="close-icon">
                <svg-icon iconClass="close" className="close-btn" @click="showPlBox = false"></svg-icon>
              </span> -->
            </div>
          </span>
        </div>
        <!-- 选择字段弹框 -->
        <select-field
          :options="fieldOptions"
          :staticOptions="staticOptions"
          @changeColumn="generateCols"
          :type="4"
          :platType="2"
        ></select-field>
        <el-button
          class="top-btn"
          icon="el-icon-refresh"
          style="margin-left: 16px"
          @click="asyncData()"
          >刷新数据</el-button
        >
        <el-button
          class="top-btn"
          icon="el-icon-download"
          @click="downloadReport"
          :loading="downloadLoading"
          >下载报表</el-button
        >
      </div>
      <div class="table-wrap">
        <el-table
          @selection-change="handleSelectionChange"
          :data="tableList"
          :max-height="tableMaxHeight"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55" :selectable="selected"> </el-table-column>
          <el-table-column
            v-for="item of staticOptions"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="true"
          >
            <template slot-scope="scope">
              <!-- 广告创意 -->
              <div class="adcreate-wrap" v-if="item.value === 'title'">
                <div class="img-wrap" v-show="scope.row.imageUrl && !scope.row.videoUrl">
                  <el-popover placement="right" width="250" trigger="hover">
                    <img style="width: 250px" :src="scope.row.imageUrl" />
                    <img class="img" slot="reference" :src="scope.row.imageUrl" />
                  </el-popover>
                </div>
                <div class="img-wrap" v-show="scope.row.videoUrl">
                  <el-popover placement="right" width="250" trigger="hover">
                    <video width="250" height="240" controls preload="metadata">
                      <source :src="scope.row.videoUrl" />
                    </video>
                    <div slot="reference">
                      <img
                        class="img"
                        slot="reference"
                        :src="scope.row.imageUrl"
                        v-show="scope.row.imageUrl"
                      />
                      <video width="50" v-show="!scope.row.imageUrl">
                        <source :src="scope.row.videoUrl" />
                      </video>
                    </div>
                  </el-popover>
                </div>
                <span class="create-text">{{ scope.row.title }}</span>
              </div>
              <span v-else>
                {{ scope.row[item.value] === null ? "--" : scope.row[item.value] }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="item of tableCols"
            :key="item.value"
            :prop="item.value"
            :label="item.label"
            :min-width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <span>{{ scope.row[item.value] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="80">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isActive"
                :disabled="
                  scope.row.isDynamicCreative === '动态创意' ||
                  !['CUSTOMER_STATUS_NORMAL', 'CUSTOMER_STATUS_SUSPEND'].includes(
                    scope.row.dataStatus
                  )
                "
                @change="(value) => changeSingleType(scope.row, value)"
              >
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page-wrap">
        <self-pagination
          :total="pageData.total"
          :pageSize="pageData.size"
          :currentPage="pageData.page"
          ref="tabelPagination"
          @getCurrentPage="changePage"
          @handleSizeChange="changePageSize"
        ></self-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import SelectField from "@/components/selectField.vue";
import { attribute, baseData, appData } from "@/config/fieldData_gdt";
import {
  getAdCountList_gdt,
  getCampaignList,
  getAdGroupList,
  getCreativeReport_gdt,
  updateCreateStatus_gdt,
  refreshReportData_gdt,
  getAdList_gdt,
} from "@/api/promotionReport.js";
import { getCommonProductList } from "@/api/api.js";
import { downLoadWrokSheet } from "@/utils/commonTools.js";
import moment from "moment";
import selectOptions from "./selectOptions.js";
import { formatTableList } from "../formatData.js";
export default {
  name: "CreativeTable",
  components: {
    SvgIcon,
    SelectField,
  },
  data() {
    return {
      loading: false,
      appList: [],
      advertiserIdList: [],
      campaignIdList: [],
      campaignLoading: false,
      adList: [],
      adLoading: false,
      createLoading: false,
      createList: [],
      optionsList: selectOptions,
      filterData: {
        systemStatus: -1,
        advertiserIds: [],
        campaignIds: [],
        adIds: [],
        time: [
          moment().subtract(7, "days").format("yyyy-MM-DD"),
          moment().subtract(1, "days").format("yyyy-MM-DD"),
        ],
        productIds: [],
        creativeIds: [],
      },
      pageData: {
        total: 15,
        size: 10,
        page: 1,
      },
      fieldOptions: [
        { title: "属性数据", list: attribute.creative },
        { title: "基础数据", list: baseData },
        { title: "应用数据", list: appData },
      ],
      staticOptions: [
        { label: "创意ID", value: "creativeId", width: "120" },
        { label: "创意名称", value: "creativeName", width: "230" },
        { label: "广告创意", value: "title", width: "250" },
      ],
      tableList: [],
      tableCols: [],
      showPlBox: false,
      tableMaxHeight: window.innerHeight - 345,
      checkedList: [],
      downloadLoading: false,
    };
  },
  mounted() {
    this.initSelectOptions();
  },
  methods: {
    selected(row) {
      if (
        row.isDynamicCreative === "动态创意" ||
        !["CUSTOMER_STATUS_NORMAL", "CUSTOMER_STATUS_SUSPEND"].includes(row.dataStatus)
      ) {
        return false; //不可勾选
      } else {
        return true; //可勾选
      }
    },
    handleSelectionChange(e) {
      if (e.length > 0) {
        this.showPlBox = true;
      } else {
        this.showPlBox = false;
      }
      this.checkedList = e;
    },
    initSelectOptions() {
      getCommonProductList({
        platType: 2,
      }).then((res) => {
        if (res.code === "0000") {
          this.appList = res.data;
        }
      });
      getAdCountList_gdt({
        platType: 2,
      }).then((res) => {
        if (res.code === "0000") {
          this.advertiserIdList = res.advertiseInfos;
        }
      });
      this.getCampaignOptions();
      this.getAdOptions();
      this.getCreateOptions();
    },
    getCampaignOptions(key) {
      getCampaignList({
        platType: 2,
        search: key,
      }).then((res) => {
        if (res.code === "0000") {
          this.campaignIdList = res.data;
        }
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.campaignLoading = true;
        setTimeout(() => {
          this.campaignLoading = false;
          this.getCampaignOptions(query);
        }, 200);
      } else {
        this.getCampaignOptions();
      }
    },
    getAdOptions(key) {
      getAdGroupList({
        platType: 2,
        search: key,
      }).then((res) => {
        if (res.code === "0000") {
          this.adList = res.data;
        }
      });
    },
    searchAdList(query) {
      if (query !== "") {
        this.adLoading = true;
        setTimeout(() => {
          this.adLoading = false;
          this.getAdOptions(query);
        }, 200);
      } else {
        this.getAdOptions();
      }
    },
    getCreateOptions(key) {
      getAdList_gdt({
        platType: 2,
        search: key,
      }).then((res) => {
        if (res.code === "0000") {
          this.createList = res.data;
        }
      });
    },
    searchCreate(query) {
      if (query !== "") {
        this.createLoading = true;
        setTimeout(() => {
          this.createLoading = false;
          this.getCreateOptions(query);
        }, 200);
      } else {
        this.getCreateOptions();
      }
    },
    clickSearch(filterData) {
      this.pageData.page = 1;
      this.$refs.tabelPagination.currentPage = 1;
      this.searchData(filterData);
    },
    formatData() {
      let parmas = {
        pageNum: this.pageData.page,
        pageSize: this.pageData.size,
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
      };
      for (let key in this.filterData) {
        let checkData = this.filterData[key];
        if (checkData === "" || checkData === -1 || key === "time") {
          continue;
        }
        if (Array.isArray(checkData)) {
          checkData.length > 0 && (parmas[key] = checkData);
        } else {
          parmas[key] = checkData;
        }
      }
      return parmas;
    },
    formatTableData(list) {
      return list.map((item) => {
        //状态
        item.isActive = item.dataStatus === "CUSTOMER_STATUS_NORMAL" ? true : false;
        let curType = this.optionsList.filterStatus.find(
          (typeItem) => typeItem.value === item.dataStatus
        );
        item.dataStatus = curType ? curType.label : "-";
        item.isDynamicCreative = item.isDynamicCreative ? "动态创意" : "自定义创意";
        //通用字段
        formatTableList(item);
        return item;
      });
    },
    searchData(filterData) {
      if (filterData) {
        this.filterData.systemStatus = -1;
        this.filterData.advertiserIds = [filterData.advertiserId];
        this.filterData.campaignIds = [Number(filterData.campaignId)];
        this.filterData.adIds = [Number(filterData.adId)];
        this.filterData.productIds = [filterData.promotedObjectId];
        this.filterData.time = filterData.time;
        this.filterData.creativeIds = [];
      }
      let parmas = this.formatData();
      this.loading = true;
      getCreativeReport_gdt(parmas).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.tableList = this.formatTableData(res.data.list);
          this.pageData.total = res.data.total;
        }
      });
    },
    generateCols(colData) {
      if (colData.custom.concat(colData.fixed).length === 0) {
        //赋值默认表格列
        colData.custom = [
          "dataStatus",
          "productName",
          "showCnt",
          "clickCnt",
          "ctr",
          "cpc",
          "thousandDisplayPrice",
          "cost",
          "convertCnt",
          "convertCntCost",
        ];
      }
      let allFieldsMap = attribute.creative.concat(baseData, appData); //所有列
      let tableCols = [];
      colData.fixed.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: true, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      colData.custom.forEach((item) => {
        let findItem = allFieldsMap.find((colItem) => colItem.value === item);
        if (findItem) {
          let tabelcolItem = { fixed: undefined, width: "120" };
          tableCols.push(Object.assign(tabelcolItem, findItem));
        }
      });
      this.tableCols = [];
      this.$nextTick(() => {
        this.tableCols = tableCols;
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData();
    },
    downloadReport() {
      this.downloadLoading = true;
      let parmas = this.formatData();
      delete parmas.page;
      delete parmas.size;
      getCreativeReport_gdt(parmas).then((res) => {
        this.downloadLoading = false;
        if (res.code === "0000") {
          const dataList = this.formatTableData(res.data.list);
          //表头映射
          const HeaderData = {};
          this.staticOptions.concat(this.tableCols).forEach((item) => {
            HeaderData[item.value] = item.label;
          });
          downLoadWrokSheet(dataList, "创意.xlsx", HeaderData);
        }
      });
    },
    //批量修改状态
    editStatus(status) {
      if (this.checkedList.length === 0) {
        this.$message({
          message: "请至少选择一条数据",
          type: "warning",
        });
        return;
      } else {
        let params = [];
        this.checkedList.map((item) => {
          params.push({
            bizId: item.creativeId,
            configuredStatus: status === 2 ? "CUSTOMER_STATUS_SUSPEND" : "CUSTOMER_STATUS_NORMAL",
            accountId: item.advertiserId,
          });
        }),
          this.commitChange(params);
      }
    },
    changeSingleType(item) {
      let params = [
        {
          bizId: item.creativeId,
          configuredStatus:
            item.dataStatus === "CUSTOMER_STATUS_NORMAL"
              ? "CUSTOMER_STATUS_SUSPEND"
              : "CUSTOMER_STATUS_NORMAL",
          accountId: item.advertiserId,
        },
      ];
      this.commitChange(params);
    },
    commitChange(data) {
      updateCreateStatus_gdt(data).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "状态修改成功",
            type: "success",
          });
          this.searchData();
        }
      });
    },
    inputSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.clickSearch();
      }, 500);
    },
    asyncData() {
      refreshReportData_gdt({ level: "REPORT_LEVEL_AD" }).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "数据同步中，预计半小时同步成功",
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.creative-wrap {
  .seletc-list {
    display: flex;
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.08);

    .select-wrap {
      width: 260px;
      margin-right: 24px;
    }
    .multiple-select {
      /deep/ .el-tag.el-tag--info:first-child {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .data-range {
      position: relative;
      /deep/.el-range__icon {
        position: absolute;
        right: 6px;
        top: 0px;
      }
      /deep/.el-range-separator {
        line-height: 24px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
    .wenhao-icon {
      margin-left: 12px;
      cursor: pointer;
    }
    .submit-btn {
      margin-left: auto;
      padding: 0 20px;
    }
  }
  .content-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    .btn-list {
      display: flex;
      align-items: center;
      height: 45px;
      .mult-wrap {
        display: flex;
        align-items: center;
        margin-right: auto;
      }
      .top-btn {
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 1);
        background: rgba(255, 255, 255, 1);
        .pl-icon {
          margin-right: 8px;
        }
      }
      .search-input {
        width: 160px;
        margin-right: 24px;
        /deep/ .el-input__icon {
          line-height: 35px;
        }
      }
    }
    .table-wrap {
      margin-top: 16px;

      .adcreate-wrap {
        width: 230px;
        display: flex;
        align-items: center;
        .img-wrap {
          width: 50px;
          height: 50px;
          flex-shrink: 0;
          margin-right: 4px;
          .img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .create-text {
        }
      }
    }
    .page-wrap {
    }
  }
}
.piliang {
  height: 45px;
  line-height: 45px;
  padding-left: 12px;
  margin-left: 12px;
  display: flex;
  justify-content: space-between;
  .batch-span {
    font-size: 13px;
    color: rgba(0, 0, 0, 1);
    a {
      color: rgba(24, 144, 255, 1);
      margin: 0 5px;
    }
  }
  .icon-list {
    margin-left: 58px;
    color: rgba(24, 144, 255, 1);
  }
  .batch-icon {
    margin-right: 26px;
    cursor: pointer;
  }
  .close-btn {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    margin: 0 16px 0 40px;
    cursor: pointer;
  }
}
</style>
<style lang="less">
.promotion-create-filter-table-select {
  .el-select-dropdown__item {
    padding-right: 40px;
  }
}
</style>
